// e2e synchronization functions
export function addTask(name) {
    if (window.__addTask__) {
        window.__addTask__(name);
    }
}
export function doneTask(name) {
    if (window.__doneTask__) {
        window.__doneTask__(name);
    }
}
// Scheduler for mobx reactions which works like the normal `delay` scheduler, but adds an e2e task, so that
// the tests wait for the scheduled reaction to execute
// This is equivalent to passing a `delay` to a reaction
// https://github.com/mobxjs/mobx/blob/13a74fe43de683249b2fd17145957b78f5befee4/packages/mobx/src/api/autorun.ts#L110C11-L110C52
export function trackedScheduler(name, delay) {
    return (f) => {
        addTask(name);
        setTimeout(() => {
            f();
            doneTask(name);
        }, delay);
    };
}
